import { IntlShape } from 'react-intl';
import * as Yup from 'yup';

import st from 'utils/shared-translations';

export const getSepaFormValidationSchema = (intl: IntlShape): object => {
  const validationSchema = {
    iban: Yup.string()
      .trim()
      .nullable()
      .required(intl.formatMessage(st['dd.sepa.validation.required']))
      .min(15, intl.formatMessage(st['dd.sepa.validation.length']))
      .max(34, intl.formatMessage(st['dd.sepa.validation.length'])),
  };

  return Yup.object().shape(validationSchema);
};

export const getBacsFormValidationSchema = (intl: IntlShape): object => {
  const validationSchema = {
    accountNumber: Yup.string()
      .trim()
      .nullable()
      .required(intl.formatMessage(st['dd.sepa.validation.required']))
      .min(6, intl.formatMessage(st['dd.bacs.account.number.validation.length']))
      .max(8, intl.formatMessage(st['dd.bacs.account.number.validation.length'])),
    branchCode: Yup.string()
      .trim()
      .nullable()
      .required(intl.formatMessage(st['dd.sepa.validation.required']))
      .min(6, intl.formatMessage(st['dd.bacs.branch.code.validation.length']))
      .max(6, intl.formatMessage(st['dd.bacs.branch.code.validation.length'])),
  };

  return Yup.object().shape(validationSchema);
};

export const getBecsFormValidationSchema = (intl: IntlShape): object => {
  const validationSchema = {
    accountNumber: Yup.string()
      .trim()
      .nullable()
      .required(intl.formatMessage(st['dd.sepa.validation.required']))
      .min(5, intl.formatMessage(st['dd.becs.account.number.validation.length']))
      .max(9, intl.formatMessage(st['dd.becs.account.number.validation.length'])),
    branchCode: Yup.string()
      .trim()
      .nullable()
      .required(intl.formatMessage(st['dd.sepa.validation.required']))
      .min(6, intl.formatMessage(st['dd.becs.branch.code.validation.length']))
      .max(7, intl.formatMessage(st['dd.becs.branch.code.validation.length'])),
  };

  return Yup.object().shape(validationSchema);
};

export const getPadFormValidationSchema = (intl: IntlShape): object => {
  const validationSchema = {
    accountNumber: Yup.string()
      .trim()
      .nullable()
      .required(intl.formatMessage(st['dd.sepa.validation.required']))
      .min(7, intl.formatMessage(st['dd.pad.account.number.validation.length']))
      .max(12, intl.formatMessage(st['dd.pad.account.number.validation.length'])),
    branchCode: Yup.string()
      .trim()
      .nullable()
      .required(intl.formatMessage(st['dd.sepa.validation.required']))
      .min(5, intl.formatMessage(st['dd.pad.branch.code.validation.length']))
      .max(5, intl.formatMessage(st['dd.pad.branch.code.validation.length'])),
    bankCode: Yup.string()
      .trim()
      .nullable()
      .required(intl.formatMessage(st['dd.sepa.validation.required']))
      .min(2, intl.formatMessage(st['dd.pad.bank.code.validation.length']))
      .max(4, intl.formatMessage(st['dd.pad.bank.code.validation.length'])),
  };

  return Yup.object().shape(validationSchema);
};
